import { Component, Input, OnInit } from "@angular/core";
import { trackByIndexFunction } from "core/functions";
import { CardComponent } from "common/card/card.component";

@Component({
	selector: "stages-floating-action-menu",
	templateUrl: "floating-action-menu.component.html",
	styleUrls: ["floating-action-menu.component.scss"],
})
export class FloatingActionMenuComponent implements OnInit {
	@Input()
	buttonTitle: string = "navigation.workspace.addelement";

	@Input()
	menuItems: MenuItem[] = [];

	@Input()
	iconClass?: string;

	@Input()
	customButtonClasses?: string[];

	@Input()
	iconSize: string = "30px";

	@Input()
	closeIcon: string = "ico ico-add";

	@Input()
	isButtonDisabled: boolean = false;

	@Input()
	isLoading: boolean = false;

	@Input()
	darkTheme: boolean = false;

	@Input()
	card?: CardComponent;

	@Input()
	mode: "button" | "menu" = "menu";

	@Input() set triggerCloseHandler(close: boolean) {
		if (close) {
			this.open = false;
			if (this.card) {
				this.card.resetHeight();
			}
		}
	}

	private INITIAL_BUBBLE_VALUE = 70;
	private DISTANCE_BETWEEN_BUBBLES = 54;
	private UPPERMARGIN = this.DISTANCE_BETWEEN_BUBBLES;
	private DELAY = 0.05;
	open = false;

	closeHandler(): void {
		this.open = false;
		if (this.card) {
			this.card.resetHeight();
		}
	}

	toggleMenu(): void {
		this.open = !this.open;
		if (this.card?.expanded) {
			const maxHeight =
				this.INITIAL_BUBBLE_VALUE + this.UPPERMARGIN + this.menuItems.length * this.DISTANCE_BETWEEN_BUBBLES;
			if (this.open && this.card.getHeight() < maxHeight) {
				this.card.setHeight(maxHeight.toString() + "px");
			} else {
				this.card.resetHeight();
			}
		}
	}

	getTransitionDelay(index: number): string {
		const delay = this.DELAY * index;
		return delay.toString() + "s";
	}

	trackByIndex = trackByIndexFunction;

	ngOnInit(): void {
		if (this.card) {
			this.card.activateTransition();
		}
	}
}
